import { posterUrl } from '../lib/tmdb'

export default function MovieCard({ movie, suggester, onClick, actions }) {
  return (
    <div
      className="fp-card flex gap-6 mb-5 cursor-pointer"
      onClick={onClick}
    >
      {/* Poster — big, rounded, with shadow */}
      <div className="w-24 h-36 rounded-xl overflow-hidden flex-shrink-0 bg-[var(--fp-border)] shadow-lg">
        {movie.poster_url ? (
          <img src={movie.poster_url} alt={movie.title} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-3xl bg-[var(--fp-surface)]">🎬</div>
        )}
      </div>

      {/* Info */}
      <div className="flex-1 min-w-0 flex flex-col justify-center py-1">
        <h3 className="fp-display text-lg text-white truncate" style={{ letterSpacing: '-0.02em' }}>
          {movie.title}
        </h3>
        <p className="text-sm text-[var(--fp-text-muted)] mt-2 leading-relaxed flex items-center gap-1.5 flex-wrap">
          {movie.content_rating && (
            <span
              className="text-[10px] font-bold px-1.5 py-0.5 rounded border inline-block"
              style={{ borderColor: 'var(--fp-border-accent)', color: '#fff', background: 'var(--fp-surface)', letterSpacing: '0.03em' }}
            >
              {movie.content_rating}
            </span>
          )}
          <span>{[movie.year, movie.genre, movie.runtime_minutes && `${Math.floor(movie.runtime_minutes / 60)}h ${movie.runtime_minutes % 60}m`, movie.tmdb_rating && `★ ${movie.tmdb_rating}`].filter(Boolean).join(' · ')}</span>
        </p>
        {suggester && (
          <div className="flex items-center gap-2 mt-3">
            <span className="w-6 h-6 rounded-full bg-[var(--fp-border-accent)] text-white text-[10px] flex items-center justify-center font-semibold">
              {suggester.charAt(0).toUpperCase()}
            </span>
            <span className="text-sm text-[var(--fp-text-muted)]">{suggester}</span>
          </div>
        )}
        {actions && <div className="mt-4">{actions}</div>}
      </div>
    </div>
  )
}
